import { angularInjectorProvider } from 'Injector';
import { type RouteAssetLoader } from 'RouteAssetLoader';

export async function globalDependenciesLoader() {
    const RouteAssetLoader: RouteAssetLoader = angularInjectorProvider
        .requireInjector()
        .get('Navigation.RouteAssetLoader');
    return await RouteAssetLoader.loadGlobalDependencies();
}
